import { render } from "./LabelInputField.vue?vue&type=template&id=94c68bd2"
import script from "./LabelInputField.vue?vue&type=script&lang=js"
export * from "./LabelInputField.vue?vue&type=script&lang=js"

import "../styles/LabelInputField.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__